import { render, staticRenderFns } from "./StaffDescription.vue?vue&type=template&id=048efab9&scoped=true&"
import script from "./StaffDescription.vue?vue&type=script&lang=js&"
export * from "./StaffDescription.vue?vue&type=script&lang=js&"
import style0 from "./StaffDescription.vue?vue&type=style&index=0&id=048efab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048efab9",
  null
  
)

export default component.exports